/* eslint-disable */
import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain'

import { Admin, AnyDomainEntity, RootEntity } from './admin-model/index.js'

export const createAdminPresets = createPresetsFactory<AnyDomainEntity, RootEntity>()

export const generatedAdminPresets = createAdminPresets([
  {
    rootEntityType: 'Admin',
    initialDomainEntities: [
      {
        id: 'Admin-1' as Admin['id'],
        type: 'Admin',
        commonAdminModelVersion: 4,
      },
    ],
  },
])
